import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Header } from "@/components/Header";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Le mot de passe doit contenir au moins 6 caractères");
    if (password !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé — vous pouvez vous connecter");
      navigate("/connexion");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-luxe min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-6 pt-36 pb-24">
        <h1 className="font-display text-3xl text-[#F5F3EE] text-center">Nouveau mot de passe</h1>
        {!token ? (
          <div data-testid="reset-invalid-link" className="mt-10 bg-[#141414] border border-white/10 p-8 text-center">
            <p className="text-sm text-[#B0B0B0]">Ce lien de réinitialisation est invalide.</p>
            <Link to="/mot-de-passe-oublie" data-testid="reset-request-new" className="inline-block mt-6 text-sm underline text-[#D4AF37]">
              Demander un nouveau lien
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-10 bg-[#141414] border border-white/10 p-8 space-y-5" data-testid="reset-password-form">
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Nouveau mot de passe</Label>
              <Input
                id="password" type="password" data-testid="reset-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="6 caractères minimum" required
                className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
              />
            </div>
            <div>
              <Label htmlFor="confirm" className="text-xs uppercase tracking-widest text-[#8F8F8F]">Confirmer le mot de passe</Label>
              <Input
                id="confirm" type="password" data-testid="reset-confirm-input" value={confirm}
                onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" required
                className="mt-2 rounded-none border-white/15 bg-transparent text-[#F5F3EE] placeholder:text-[#5A5A5A] focus-visible:ring-[#D4AF37]"
              />
            </div>
            <button
              type="submit" data-testid="reset-submit-button" disabled={loading}
              className="w-full bg-[#D4AF37] text-[#0A0A0A] font-semibold py-4 text-sm uppercase tracking-widest hover:bg-[#C9A227] transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />} Valider
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
